"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Form = _interopRequireDefault(require("react-bootstrap/Form"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FormHelperText = _ref => {
  let {
    feedbackType,
    helperText,
    id,
    feedbackDescription
  } = _ref;
  if (!helperText) {
    // if there is no message, don't render the container
    return null;
  }
  if (feedbackType === 'valid') {
    return /*#__PURE__*/_react.default.createElement(_Form.default.Control.Feedback, {
      type: "valid",
      id: id || feedbackDescription
    }, helperText);
  }
  if (feedbackType === 'invalid') {
    return /*#__PURE__*/_react.default.createElement(_Form.default.Control.Feedback, {
      type: "invalid",
      id: id || feedbackDescription
    }, helperText);
  }

  // returns regular helperText as default
  return /*#__PURE__*/_react.default.createElement(_Form.default.Text, {
    id: id || feedbackDescription
  }, helperText);
};

/**
 * A feedback or text form helper, used to provide additional context to form
 * fields.
 */
FormHelperText.propTypes = {
  /**
   * The ID of the HTML element. Deprecated in favor of `id`.
   */
  feedbackDescription: _propTypes.default.string,
  /**
   * The type of feedback for the user. This controls the appearance of helperText.
   */
  feedbackType: _propTypes.default.oneOf(['helper', 'valid', 'invalid']),
  /**
   * The text for feedback to the user. The appearance is controlled by feedbackType.
   */
  helperText: _propTypes.default.string,
  /**
   * The ID of the HTML element.
   */
  id: _propTypes.default.string
};
var _default = exports.default = FormHelperText;